import { Box, Checkbox, FormControlLabel, Link, Stack, Typography, Dialog, Tooltip, IconButton, SvgIcon } from '@mui/material'
import React, { useState } from 'react'

import { useForm, register, watch, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { updateFinanceTechnologies } from 'api/users';
import AddTechnology from './AddTechnology';
import { useSnackbar } from 'components/snackbar';
import { useMediaQuery, Drawer, Card, CardContent, Button, Paper } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useBackNavigationDialog } from 'hooks/useBackNavigationDialog';

const FinanceTechnicalCompetencies = ({ setUpdating, financeTechologiesData, onFinanceDataChange, handleFinance, Finance }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const { enqueueSnackbar } = useSnackbar();
    const [allFinanceTechnologiesList, setAllFinanceTechnologiesList] = useState([
        'Microsoft Excel',
        'Microsoft PowerPoint',
        'Microsoft Word',
        'Tally ERP',
        'Power BI',
        'Tableau',
        'SQL',
        'Python (Pandas, NumPy)',
        'Google Data Studio',
        'QuickBooks',
        'SAP FICO',
        'SAP S/4HANA',
        'Oracle Financials Cloud',
        'NetSuite ERP',
        'Xero',
        'Hyperion',
        'Alteryx',
        'Macros and VBA',
        'Power Query',
        'SAP Crystal Reports',
        'IBM Cognos Analytics',
        'Looker',
        'Looker Studio',
        'Bloomberg Terminal',
        'Reuters Eikon',
        'MATLAB',
        'R',
        'Adaptive Insights',
        'SAS (Statistical Analysis System)',
        'Anaconda',
        'Workday',
        'ETL Tools (Informatica, Talend)',
        'Tableau Prep',
        'Zoho Analytics',
        'Domo',
        'AWS (Amazon Web Services)',
        'Google Cloud Platform (GCP)',
        'Azure (Microsoft Cloud)',
        'Java',
        'C++',
        'Scala',
        'Hadoop',
        'QuantLib',
        'Spotfire',
        'Dundas BI',
        'Qlik Sense',
        'BlackLine',
        'Wallstreet Suite (ION)',
        'Kyriba',
        'HighRadius',
        'Trintech (Cadency)',
        'Tagetik (Wolters Kluwer)',
        'OneStream',
        'Anaplan',
        'Prophix',
        'Board International',
        'Coupa',
        'Ariba (SAP)',
        'Basware',
        'FloQast',
        'NetSuite Planning & Budgeting',
        'Xero Projects',
        'FactSet',
        'Capital IQ (S&P)',
        'Morningstar Direct',
        'PitchBook',
        'Carta',
        'Workiva',
        'AuditBoard',
        'CaseWare',
        'LeaseQuery',
        'SAP BPC',
        'Oracle PBCS / EPBCS'
    ]);

    const [open, setOpen] = useState(false);
    const [checkedState, setCheckedState] = useState(financeTechologiesData);

    const [bindTechnologyList, setBindTechnologyList] = useState(financeTechologiesData);
    const [selectedSoftware, setSelectedSoftware] = useState(
        financeTechologiesData.map(tech => tech)
    );

    const [showFlag, setShowFlag] = useState(false);
    const [isReadOnly, setReadOnly] = useState(Finance ? true : false);

    /**
     * Opens the OTP verification dialog.
     * @function
     */
    // const handleOpenOtpDialog = () => {
    //     setOpen(true);
    // };


    /**
     * Closes the OTP verification dialog.
     * Sets the state to close the dialog.
     */

    // const handleClose = () => {
    //     setOpen(false);
    // };

    /**
     * Handles the addition of more technologies to the user's profile.
     * Updates the state of the component with the new technologies.
     * If the user is a finance professional, the new technologies are
     * bound to the user's profile.
     * Submits the form with the new technologies.
     * @param {Array} moreTechnologies - The array of technology names to add.
     */
    const handleAddMoreTechnology = async (moreTechnologies) => {
        setCheckedState(moreTechnologies);
        setSelectedSoftware(moreTechnologies);
        if (Finance) setBindTechnologyList(moreTechnologies);
        await onSubmit("", false, moreTechnologies, true);
    }

    /**
     * Handles the change event for a single technology checkbox.
     * Updates the state with the new set of selected technologies.
     * If the user is a finance professional, the new technologies are
     * bound to the user's profile.
     * Submits the form with the new technologies.
     * @param {string} name - The name of the technology that was checked or unchecked.
     * @param {boolean} isChecked - Whether the technology was checked or unchecked.
     * @param {number} index - The index of the technology in the list of all technologies.
     */
    const handleCheckboxChange = async (name, isChecked, index) => {
        let updatedCheckedState = !isChecked ? checkedState.filter(item => item !== name) : [...checkedState, name];

        if (updatedCheckedState && updatedCheckedState.length) {
            setCheckedState(updatedCheckedState);
            setSelectedSoftware(updatedCheckedState);
        } else {
            setCheckedState([]);
            setSelectedSoftware([]);
        }
        await onSubmit(name, isChecked, [], false, updatedCheckedState);
    };

    const onSubmit = (async (item, ischecked, data, isAddMore, updatedCheckedState) => {
        try {
            setUpdating(true);
            if (selectedSoftware && selectedSoftware.length <= 12) {
                if (Finance) {
                    handleFinance('financeTechologiesData', (data?.length > 0 ? data : updatedCheckedState));
                    return;
                }
                const response = await updateFinanceTechnologies({ item, ischecked, data });
                if (response?.success === true && response.data) {
                    if (isAddMore) {
                        setCheckedState(response.data);
                        setSelectedSoftware(response.data);
                        setBindTechnologyList(response.data);
                    }
                    onFinanceDataChange();
                } else {
                    enqueueSnackbar(response.message, { variant: 'error' });
                }
            } else {
                setShowFlag(true);
            }
        } catch (e) {
            setUpdating(false);
        }
    });

    const { openDialog, closeDialog, dialogLocation } = useBackNavigationDialog();
    const dialogIds = dialogLocation.state?.dialogIds || [];

    const openSkillDrawer = dialogIds.includes("techSkills");

    const handleCloseSkillDrawer = () => {
        closeDialog('techSkills');
    };
    const handleOpenSkillDrawer = () => {
        openDialog('techSkills');
    };

    return (
        <Box className={Finance && isReadOnly ? "finance-tech-wrapper" : ""}>
            <Tooltip title={isReadOnly ? "Data updated in this section will be reflected across all resumes" : ''} arrow followCursor placement='top'>
                <Box mb={2}>
                    <Stack direction="row" alignItems={'center'} justifyContent={'space-between'}>
                        <Typography className="step-heading" variant="h6" gutterBottom>
                            Finance Technical Competencies
                        </Typography>
                        {Finance && isReadOnly &&
                            <IconButton aria-label="delete" sx={{ padding: 0 }} className="edit-icon" disableRipple onClick={() => { setReadOnly(false) }}>
                                <SvgIcon>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M12.2906 16.0002H2.10131C0.944535 16.0002 0.00341797 15.0592 0.00341797 13.9023V3.71301C0.00341797 2.55623 0.94442 1.61511 2.10131 1.61511H6.77045C7.10161 1.61511 7.36983 1.88332 7.36983 2.21448C7.36983 2.54564 7.10161 2.81385 6.77045 2.81385H2.10131C1.60534 2.81385 1.20225 3.21694 1.20225 3.71291V13.9022C1.20225 14.3982 1.60534 14.8013 2.10131 14.8013H12.2906C12.7866 14.8013 13.1897 14.3982 13.1897 13.9022V9.23306C13.1897 8.9019 13.4579 8.63369 13.789 8.63369C14.1202 8.63369 14.3884 8.9019 14.3884 9.23306V13.9022C14.3884 15.059 13.4475 16.0002 12.2906 16.0002Z" fill="#1575C6" />
                                        <path d="M4.44385 9.0085L11.0011 2.45129L13.5476 4.9978L6.99036 11.555L4.44385 9.0085Z" fill="#1575C6" />
                                        <path d="M15.7113 1.43961L14.5605 0.28882C14.1754 -0.0962733 13.5506 -0.0962733 13.1647 0.28882L11.8491 1.60444L14.3956 4.15095L15.7113 2.83533C16.0963 2.45024 16.0964 1.82545 15.7113 1.43961Z" fill="#1575C6" />
                                        <path d="M3.67534 9.9352L3.08272 12.5229C3.02878 12.7597 3.24005 12.971 3.47681 12.917L6.06455 12.3244L3.67534 9.9352Z" fill="#1575C6" />
                                    </svg>
                                </SvgIcon>
                            </IconButton>
                        }
                    </Stack>
                    <Typography className="step-info" variant="body2" gutterBottom>
                        Please select or enter upto 12 finance technical skills in which you have reasonable proficiency
                    </Typography>
                </Box>

                <Box className="ftc-checkbox-wrapper">
                    <Stack direction="row" flexWrap="wrap" mb={1}>
                        {bindTechnologyList && bindTechnologyList.length > 0 ?
                            bindTechnologyList.map((software, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            checked={checkedState.includes(software)}
                                            onChange={(e) => handleCheckboxChange(software, e.target.checked, index)}
                                            tabIndex={-1}
                                        />
                                    }
                                    label={software}
                                    disabled={isReadOnly}
                                />
                            )) :
                            allFinanceTechnologiesList.slice(0, 12).map((software, index) => (
                                <FormControlLabel
                                    key={index}
                                    control={
                                        <Checkbox
                                            checked={checkedState.includes(software)}
                                            onChange={(e) => handleCheckboxChange(software, e.target.checked, index)}
                                            tabIndex={-1}
                                        />
                                    }
                                    label={software}
                                    disabled={isReadOnly}
                                />
                            ))
                        }
                    </Stack>
                    {showFlag && (
                        <Typography style={{ color: 'red', fontSize: 'small' }} mb={2}>
                            Please select upto 12 finance technical skills.
                        </Typography>
                    )}
                    {!isReadOnly && <Link className="add-more-technology-link" underline="none" size="small" onClick={handleOpenSkillDrawer} tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                handleOpenSkillDrawer();
                            }
                        }}
                    >
                        Select from complete list
                    </Link>}
                </Box>
            </Tooltip>

            {isMobile ?
                <Drawer
                    open={openSkillDrawer}
                    anchor="bottom"
                    onClose={handleCloseSkillDrawer}
                    className="forgot-password-dialog otp-dialog-wrapper"
                >
                    <AddTechnology onClose={handleCloseSkillDrawer} technology={allFinanceTechnologiesList} selectedsoftware={selectedSoftware} onAddTechnology={handleAddMoreTechnology} />
                </Drawer> :
                <Dialog
                    open={openSkillDrawer}
                    onClose={handleCloseSkillDrawer}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className="otp-dialog-wrapper"
                >
                    <AddTechnology onClose={handleCloseSkillDrawer} technology={allFinanceTechnologiesList} selectedsoftware={selectedSoftware} onAddTechnology={handleAddMoreTechnology} />
                </Dialog>
            }

        </Box>
    )
}

export default FinanceTechnicalCompetencies
